<script setup>
import {defineComponent, onMounted, ref} from 'vue'
import axios from 'axios'
import {useWindowSize} from '@vueuse/core'

defineComponent({
  name: 'Home'
})
const { width } = useWindowSize()

const catalogue = ref([])

onMounted(() => {
  axios
    .get('/produits')
    .then(succes => {
      catalogue.value = succes.data.filter(produit => produit.rechargeable === false)
    }, error => {
      console.error('ERREUR', error.body)
    })
})

</script>

<template>
  <div class="home container overflow-auto">
    <h1>Commander ou recharger un titre de transport</h1>

    <p v-if="false">Le Ignimus et estiate doloria tiberuntio vent. Sitasperibus cusant, sedi comniation nobis accullupti !</p>

    <!-- carte représentant les produits Achats dans le tms -> Seulement le PASS_SOLO -->
    <div id="store" class="row pt-sm-0 pt-lg-5" style="justify-self: center; text-align: center;">
      <!-- Formulaire de contact pour créer une carte -->
      <div v-if="width > 1199" class="col-xl-2" style="margin-top: 300px;">
        <img src="@/assets/little-square-2.png" alt="image home gauche">
      </div>
      <div class="col-md-12 col-xl-4" style="margin-top: 50px;">
          <router-link :to="{name: 'rechargement'}">
            <a class="bouton_achat btn">
              <img src="@/assets/recharger-full.png" alt="Carte de rechargement">
            </a>
          </router-link>
      </div>
      <div class="col-md-12 col-xl-4" style="margin-top: 50px;">
        <router-link :to="{name: 'fabrication_carte'}">
          <a class="bouton_achat btn">
            <img src="@/assets/comander-full.png" alt="Fabrication de carte">
          </a>
        </router-link>
      </div>
      <div v-if="width > 1199" class="col-xl-2">
        <img src="@/assets/little-square-1.png" alt="image home droite">
      </div>
    </div>
  </div>



</template>

<style scoped lang="scss">
@import "@/assets/main";

p{
  font-weight: bold;
  text-align: center;
}

.home {

  #store {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;

    .carte {
      box-shadow: 0 0 10px 0 lightgray;
      margin: 1rem;

      @media (max-width: 576px) {
        margin-bottom: 2rem;
        margin-left: 1rem;
      }
      @media (min-width: 768px) and (max-width: 991.98px) {
        margin-bottom: 2.5rem;
        margin-left: 2.5rem;
      }
      @media (min-width: 992px) and (max-width: 1199.98px) {
        margin-bottom: 3rem;
        margin-left: 3.75rem;
      }

      .libelle {
        font-family: var(--font-title), sans-serif;
        font-weight: bold;
      }

      .div_price {
        margin-top: 2rem;
        .price {
          font-family: var(--font-title), sans-serif;
          font-weight: 900;
          color: var(--color-bleu-logo);
          font-size: 25px;
        }

        .div_btn {
          text-align: end;

          .bouton_achat {
            @include boutons;
          }

          .bouton_achat:hover {
            @include boutons_hover;
          }
        }
      }
    }

  }
}
</style>
